<script>
  import { faClock } from '@fortawesome/pro-regular-svg-icons'

  import TimePicker from '../svelte-time-picker/src/TimePicker.svelte'

  import { getContext } from 'svelte'

  import dayjs from 'dayjs'
  import customParseFormat from 'dayjs/plugin/customParseFormat'
  dayjs.extend(customParseFormat)

  import Icon from '../Icon/'
  import { Dropdown, DropdownContent } from '../Dropdown/'
  import { cssPrefix } from '../helper-classes.js'

  // export let elementName
  export let variant = null
  export let config = {}
  export let id = null

  const element = getContext('currentElement')

  const tare = new Date()
  tare.setHours(0)
  tare.setMinutes(0)
  tare.setSeconds(0)

  let timePickerOptions
  let onTimeChange

  if (variant === 'Default') {
    config.textType = true

    onTimeChange = e => {
      // console.log('time changed', e)
      element.setValue(
        `${e.detail.getHours().toString().padStart(2, '0')}:${e.detail.getMinutes().toString().padStart(2, '0')}`
      )
      tare.setHours(e.detail.getHours())
      tare.setMinutes(e.detail.getMinutes())
    }
    timePickerOptions = { hasButtons: false, is24h: true }
  }

  if (variant === 'Dropdown') {
    config.selectType = true
    let start = new Date()
    let end = new Date()
    const [h, m] = ($element.min || '00:00').split(':')
    start.setHours(h)
    start.setMinutes(m)
    start = dayjs(start)
    const [eh, em] = ($element.max || '23:59').split(':')
    end.setHours(eh)
    end.setMinutes(em)
    end = dayjs(end)
    // console.log({start, h, m, end, eh, em})
    config.values = []
    while (start.valueOf() < end.valueOf()) {
      config.values.push(start.format('HH:mm'))
      start = start.add(config.step || 30, 'minute')
    }
  }

  const layout = config.layout || getContext('formGroupLayout')
  if (layout === 'TwoCols') {
    config.blockClasses = [`${cssPrefix}form-block`, 'is-horizontal', 'has-control']
  } else {
    config.blockClasses = [`${cssPrefix}form-block`]
  }

  let dropdown
</script>

<div class={config.blockClasses && config.blockClasses.join(' ')}>
  <div class={`${cssPrefix}form-label`}>
    <div class={`${cssPrefix}label`} class:is-required={$element.required && !$element.disabled}>
      <label for={id}>{$element.label}</label>
    </div>
  </div>

  <div class={`${cssPrefix}form-field`}>
    <div class={`${cssPrefix}controls is-grouped`}>
      {#if variant === 'Native'}
        <div class={`${cssPrefix}control`}>
          <slot inputClass={$element.error ? `${cssPrefix}input has-error` : `${cssPrefix}input`} />
        </div>
      {:else if variant === 'Dropdown'}
        <div class={`${cssPrefix}control is-select`} class:is-loading={$element.loading}>
          <div
            class={`${cssPrefix}select`}
            class:is-disabled={$element.disabled}
            class:is-readonly={$element.readonly}
            class:has-error={$element.error}
          >
            <slot>
              <option>xxxxxx</option>
            </slot>
          </div>
        </div>
      {:else}
        <div class={`${cssPrefix}control is-time time-picker has-icons-end`}>
          <Icon icon={faClock} iconClass="is-end" />
          <Dropdown bind:this={dropdown}>
            <span
              role="button"
              tabindex="0"
              on:click={() => {
                dropdown.toggle()
              }}
              on:keypress={e => {
                if (e.key === 'Enter') {
                  dropdown.toggle()
                }
              }}
            >
              <slot inputClass={$element.error ? `${cssPrefix}input has-error` : `${cssPrefix}input`} />
            </span>
            <DropdownContent narrow>
              <TimePicker
                date={new Date(tare.getTime())}
                options={timePickerOptions}
                on:change={onTimeChange}
                on:change
              />
            </DropdownContent>
          </Dropdown>
        </div>
      {/if}
    </div>
  </div>

  {#if $element.info}
    <div class={`${cssPrefix}form-info`} class:has-info={$element.info}>
      <div class={`${cssPrefix}message`}>
        <p id="${id}-description">{$element.info}</p>
      </div>
    </div>
  {/if}

  {#if $element.error}
    <div class={`${cssPrefix}form-error`}>
      <div class={`${cssPrefix}message is-status-error`}>
        <p id="${id}-error">{$element.error}</p>
      </div>
    </div>
  {/if}
</div>
